const blockListDownload = () => {
    const grids = document.querySelectorAll('[data-block="list-download"]');
    if (!grids.length) return;

    grids.forEach(grid => {
        const section = grid.closest('.block-list-download');
        const selects = section.querySelectorAll('.block-list-download__select');

        const fetchDownloads = () => {
            const categoria = section.querySelector('[data-filter="categoria"]')?.value || '';
            const lingua    = section.querySelector('[data-filter="lingua"]')?.value || '';

            grid.classList.add('is-loading');

            $.ajax({
                url:  ajax_auth_object.ajaxurl,
                type: 'POST',
                data: {
                    action: 'get_downloads_filtered',
                    categoria,
                    lingua,
                },
                success(response) {
                    if (response.success) {
                        grid.innerHTML = response.data.html;
                    }
                },
                complete() {
                    grid.classList.remove('is-loading');
                },
            });
        };

        selects.forEach(select => select.addEventListener('change', fetchDownloads));
    });
};

export default blockListDownload;
